module.exports = __webpack_public_path__ + "img/2016pigc.759928e0.png";